module.exports = __webpack_public_path__ + "img/goods-manage-mid.b56d5f4b.png";